import React from 'react';
import Input from '../input/input.jsx';
import css from './signin-card.scss';
import email from '../../assets/images/f_email.svg';
import mailto from '../../assets/images/f_mailto.svg';
import password from '../../assets/images/f_password.svg';
import google from '../../assets/images/f_google.svg';
import facebook from '../../assets/images/f_facebook.svg';
import apple from '../../assets/images/f_apple.svg';
import LoginButton from '../../components/button/button';
import SocialButton from '../../components/button/button';
import { Link } from 'react-router-dom';
import auth from '../../store/auth.js'
import { observer } from 'mobx-react';

@observer
class SigninCard extends React.Component {
    render() {
        return (
            <div className={css.root}>
                <h1>Вход</h1>
                <form action="/feed" noValidate className={css.form}>
                    <Input id="email" img={email} caption="Email" type="email" required errors />
                    <Input id="password" img={password} caption="Пароль" type="password" link='#' linkText='Забыли пароль?' required errors />
                    <Input id="required" txt='*' caption="обязательные для заполнения поля" type="txt" />
                    <LoginButton style={css.button}
                        onClick={auth.isLoggedIn ? () => auth.logout() : () => auth.login()}
                        caption='Войти'>
                    </LoginButton>
                    <Link className={css.form__link} to="/signup">Зарегистрироваться</Link>
                </form>

                <div className={css.OR}>
                    <span>или</span>
                </div>
                <div className={css.socialSign}>
                    <SocialButton style={`${css.socialSign__btn} ${css.socialSign__btn__google}`} onClick={() => { auth.login() }}
                        caption='Войти с Google' img={google} name="google">
                    </SocialButton>
                    <SocialButton style={`${css.socialSign__btn} ${css.socialSign__btn__facebook}`} onClick={() => { auth.login() }}
                        caption='Войти с Facebook' img={facebook} name="facebook">
                    </SocialButton>
                    <SocialButton style={`${css.socialSign__btn} ${css.socialSign__btn__apple}`} onClick={() => { auth.login() }}
                        caption='Войти с Apple' img={apple} name="apple">
                    </SocialButton>
                </div>
                <div className={css.mailto}>
                    <img src={mailto} alt="mailto" />
                    <a className={css.form__link} href="mailto:support@victoriasmedical.ai">support@victoriasmedical.ai</a>
                </div>
            </div>

        );
    }
}

export default SigninCard;